<template>
    <div class="account-data" v-loading="loading">
        <div class="account-data__content">
            <div>
                <div
                    v-for="(_, index) in projects"
                    class="account-data__item"
                    :key="index"
                >
                    <div class="delete-block">
                        <div
                            class="delete-block__btn"
                            @click="
                                rmParticipationInProject(projects[index], index)
                            "
                            data-voicetext="Удалить добавленный блок"
                        >
                            {{
                                isMobile
                                    ? 'Удалить блок'
                                    : 'Удалить добавленный блок'
                            }}<span>+</span>
                        </div>
                    </div>
                    <WideProject v-model="projects[index]"></WideProject>
                </div>
                <div
                    class="add-block-btn"
                    :class="{ 'add-block-btn--mt': projects.length }"
                    @click="addParticipationInProject"
                >
                    Добавить проект
                </div>
            </div>
        </div>
        <FixedSaveBtn
            v-if="showFixedSaveBtn"
            @close="closeFixedBtn"
        >
            <ActionButton
                @b-action="saveData"
                :b-color="saveButton.color"
                b-t-color="white"
                :b-text="saveButton.fixedText"
                class="save-block__btn--position save-block__btn"
            />
        </FixedSaveBtn>
        <div
            class="save-block"
        >
            <ActionButton
                ref="inProjectBtn"
                @b-action="saveData"
                :b-color="saveButton.color"
                b-t-color="white"
                :b-text="saveButton.text"
                class="save-block__btn--position save-block__btn"
            />
        </div>
    </div>
</template>

<script>
import ActionButton from '../../../UI/inputs/ActionButton';
import WideProject from './WideProject';
import FixedSaveBtn from '../FixedSaveBtn';

import { mapGetters, mapActions } from 'vuex';

const getters = ['getParticipationInProjects', 'isMobile'];
const actions = [
    'loadParticipationInProjects',
    'addParticipationInProjects',
    'removeParticipationInProject',
    'updateParticipationInProject',
];

export default {
    name: 'WideParticipationInProjectsData',
    data: () => ({
        showFixedSaveBtn: false,
        observer: null,
        projects: [],
        loading: false,
        saveButton: {
            fixedText: 'Сохранить изменения',
            text: 'Сохранить',
            color: '#4663AB',
            status: 'wait',
        },
    }),
    computed: {
        ...mapGetters(getters),
    },
    components: {
        ActionButton,
        WideProject,
        FixedSaveBtn,
    },
    methods: {
        ...mapActions(actions),
        closeFixedBtn() {
            this.showFixedSaveBtn = false;
            this.observer ? this.observer.disconnect() : '';
        },
        async addParticipationInProject() {
            await this.addParticipationInProjects();
        },
        async rmParticipationInProject(project, index) {
            await this.removeParticipationInProject({
                project: project,
                index: index,
            });
        },
        async saveData() {
            if (this.saveButton.status != 'wait') return;
            this.saveButton.status = 'wait';
            this.saveButton.color = '#4663AB';
            this.saveButton.text = 'Сохранение...';
            this.saveButton.fixedText = 'Сохранение...';

            try {
                const promises = [];
                this.projects.forEach((project, index) => {
                    promises.push(
                        this.updateParticipationInProject({
                            project: project,
                            index: index,
                        })
                    );
                });
                await Promise.all(promises);
                this.saveButton.status = 'wait';
                this.saveButton.color = '#238C47';
                this.saveButton.text = 'Данные сохранены';
                this.saveButton.fixedText = 'Данные сохранены';
                this.showFixedSaveBtn = false;
                this.observer ? this.observer.disconnect() : '';

                setTimeout(() => {
                    this.saveButton.text = 'Сохранить';
                    this.saveButton.fixedText = 'Сохранить изменения';
                    this.saveButton.color = '#4663AB';
                }, 2000);
            } catch (e) {
                this.saveButton.status = 'wait';
                this.saveButton.color = '#F7E9F1';
                this.saveButton.text = 'Ошибка! извините..';
                this.saveButton.fixedText = 'Ошибка! извините..';

                setTimeout(() => {
                    this.saveButton.text = 'Сохранить';
                    this.saveButton.fixedText = 'Сохранить изменения';
                    this.saveButton.color = '#4663AB';
                }, 2000);
            }
        },
    },
    async mounted() {
        this.loading = true;
        await this.loadParticipationInProjects();
        this.projects = this.getParticipationInProjects;
        this.loading = false;
        this.observer = new IntersectionObserver((entries) => {
            entries.forEach( (entry) => {
                !entry.isIntersecting && Math.sign(entry.boundingClientRect.top) === 1 ? this.showFixedSaveBtn = true : this.showFixedSaveBtn = false;
            });
        });
        this.$watch('getParticipationInProjects', () => {
            this.observer.observe(this.$refs.inProjectBtn.$el);
        }, {deep: true});
    },
    beforeDestroy() {
        this.observer ? this.observer.disconnect() : '';
    },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/rem';
@import '~@/styles/account-data.scss';
</style>
